export default function fieldVisibility(field_visibility) {
  if (!field_visibility) {
    return "block"
  } else {
    return field_visibility ? "block" : "none"
  }
}
